import {
  IFormField,
  ISelectOption,
  ISourceDependence
} from '@app/src/common/model/FormField';

export interface IFormConfiguration {
  forms: IConfigurableForm[];
  dictionaries: IDictionary[];
  translations: ITranslations;
}

export interface IConfigurableForm {
  type?: string;
  name?: string;
  description?: string;
  defaultType?: boolean;
  extendDefault?: boolean;
  selfRegistration?: boolean;
  layout?: FormLayout;
  fields: IFormField[];
}

export interface IDictionary {
  [key: string]: ISelectOption[];
}

export interface IDependentDictionary {
  [key: string]: ISourceDependence;
}

export interface ITranslations {
  en: { [key: string]: string };
  de: { [key: string]: string };
}

export interface IFormType {
  id?: string;
  type: string;
  name?: string;
  description?: string;
  defaultType?: boolean;
  notTranslatable?: boolean;
}

export enum FormLayout {
  FORM,
  WIZARD
}
